import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifyTokenRequest } from "../redux/actions/profileActions";

const EmailVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loading, success, error, message } = useSelector(
    (state) => state.profile
  );

  useEffect(() => {
    const token = searchParams.get("token");
    const email = searchParams.get("email");

    if (token && email) {
      dispatch(verifyTokenRequest(token, email));
    } else {
      navigate("/login");
    }
  }, [searchParams, dispatch, navigate]);

  // Auto redirect to login after successful verification
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        navigate("/login");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [success, navigate]);

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src="https://washi.s3.amazonaws.com/RiskReport360.png"
            alt="Almata Logo"
            style={{ height: "100px", width: "170px" }}
            loading="lazy"
            className="mb-0"
          />
          <h1 className="login-title">Email Verification</h1>
        </div>

        <div className="text-center">
          {loading && (
            <div>
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Verifying your email...</p>
            </div>
          )}

          {success && (
            <>
              <div className="alert alert-success d-flex align-items-center justify-content-center">
                <p className="mb-0">{message}</p>
              </div>
              <div className="alert alert-success d-flex align-items-center justify-content-center">
                <p className="mb-0">Redirecting to login...</p>
              </div>
            </>
          )}

          {error && (
            <div className="alert d-flex align-items-center justify-content-center alert-danger">
              <p className="mb-0">{error}</p>
            </div>
          )}

          {(success || error) && (
            <button
              className="login-btn w-100 mt-3"
              onClick={handleBackToLogin}
            >
              Back to Login
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
